import axios from 'axios';
import { datajs, datajsAll, debounce } from '../shared/utils';
import { Tab } from 'bootstrap';

const staffSearch = () => {
	const input = datajs('staff-search-input');
	const inputWrapper = datajs('staff-search-input-wrapper');
	const letters = datajsAll('staff-search-letter');
	const showAllStaffBtn = datajs('show-all-staff');
	const showAllStaffBtnShowAllText = datajs('show-all-staff-show-all-text');
	const showAllStaffBtnShowMoreText = datajs('show-all-staff-show-more-text');
	const staffSearchResultContainer = datajs('staff-search-result-container');
	const staffGroupingsTabsTriggers = datajs('staff-groupings-tabs-triggers');
	const staffGroupingsTabs = datajs('staff-groupings-tabs');
	let isLetterSearch = false;
	let searchInput = '';

	if (!input) {
		return;
	}

	const resetSearchFormToInitialState = function () {
		showAllStaffBtnShowAllText?.classList.remove('d-none');
		showAllStaffBtnShowMoreText?.classList.add('d-none');

		if (showAllStaffBtn?.dataset?.showInitially === 'true') {
			showAllStaffBtn?.classList.remove('d-none');
		} else {
			showAllStaffBtn?.classList.add('d-none');
		}
	};

	// Search
	const staffSearch = function (e) {
		e.preventDefault();

		const adminUrl = window.AppGlobals.adminUrl;
		const params = new URLSearchParams();
		const eventTarget = e.target;
		const termSlug = input.dataset.termSlug;
		const emptyWithoutInput = input.dataset.emptyWithoutInput;
		let page = parseInt(staffSearchResultContainer.dataset.page, 10);

		let showAllStaff = false;

		if (!staffSearchResultContainer) {
			console.error('A valid container to populate with the search result is not defined');
			return;
		}

		// Handle letter clicks
		if (e.type === 'click') {
			// Letter click
			if (eventTarget.dataset.js === 'staff-search-letter') {
				page = 1;
				input.value = '';

				if (eventTarget.classList.contains('is-active')) {
					isLetterSearch = false;
					searchInput = '';
					eventTarget.classList.remove('is-active');
				} else {
					isLetterSearch = true;
					searchInput = eventTarget.innerHTML;
					letters.forEach((letter) => letter.classList.remove('is-active'));
					eventTarget.classList.add('is-active');
				}
			}

			// If "Show all staff button is pressed"
			if (
				eventTarget.dataset.js === 'show-all-staff' ||
				eventTarget.dataset.js === 'show-all-staff-show-all-text' ||
				eventTarget.dataset.js === 'show-all-staff-show-more-text'
			) {
				showAllStaff = true;
			}
		}

		// Remove any active letter when the input field is used
		if (e.type === 'input') {
			page = 1;
			isLetterSearch = false;
			searchInput = input.value;
			letters.forEach((letter) => letter.classList.remove('is-active'));
		}

		params.append('action', 'staff_search');
		params.append('s', searchInput);
		params.append('term_slug', termSlug);
		params.append('empty_without_input', emptyWithoutInput);
		params.append('is_letter_search', isLetterSearch);
		params.append('show_all_staff', showAllStaff);
		params.append('page', page);

		staffSearchResultContainer.classList.add('is-searching');
		inputWrapper.classList.add('is-searching');

		axios
			.post(`${adminUrl}admin-ajax.php`, params)
			.then((res) => {
				if (!res.data.success) {
					return;
				}

				// Apply result
				if (res.data.data?.posts) {
					if (page === 1) {
						staffSearchResultContainer.innerHTML = res.data.data.posts;
					} else {
						staffSearchResultContainer.innerHTML += res.data.data.posts;
					}
				} else {
					staffSearchResultContainer.innerHTML = '';
				}

				// Handle pagination
				if (res.data.data?.hasMorePosts) {
					showAllStaffBtn?.classList.remove('d-none');
					showAllStaffBtnShowAllText?.classList.add('d-none');
					showAllStaffBtnShowMoreText?.classList.remove('d-none');
					staffSearchResultContainer.dataset.page = res.data.data.nextPage;
				} else {
					if (typeof res.data.data === 'undefined') {
						resetSearchFormToInitialState();
					} else {
						showAllStaffBtn?.classList.add('d-none');
					}
				}
			})
			.catch((error) => {
				console.error(error);
			})
			.finally(() => {
				// Update tab/search container visibility
				staffGroupingsTabs?.classList.add('d-none');
				staffSearchResultContainer.classList.remove('d-none');
				staffGroupingsTabsTriggers?.querySelectorAll('button')?.forEach((trigger) => {
					trigger.classList.remove('active');
				});
				staffSearchResultContainer.classList.remove('is-searching');
				inputWrapper.classList.remove('is-searching');
			});
	};

	// Tabs
	if (staffGroupingsTabsTriggers) {
		const triggerTabList = staffGroupingsTabsTriggers.querySelectorAll('button');
		triggerTabList.forEach((triggerEl) => {
			const tabTrigger = new Tab(triggerEl);

			triggerEl.addEventListener('click', (event) => {
				event.preventDefault();
				tabTrigger.show();

				// Update tab/search container visibility
				staffGroupingsTabs.classList.remove('d-none');
				staffSearchResultContainer.classList.add('d-none');

				// Reset state
				input.value = '';
				staffSearchResultContainer.dataset.page = 1;
				resetSearchFormToInitialState();
			});
		});
	}

	const debouncedStaffSearch = debounce(staffSearch, 300);

	input.addEventListener('input', debouncedStaffSearch);
	letters.forEach((letter) => {
		letter.addEventListener('click', staffSearch);
	});

	if (showAllStaffBtn) {
		showAllStaffBtn.addEventListener('click', staffSearch);
	}
};

export default staffSearch;
